export const EXECUTE_QUOTE = 'EXECUTE_QUOTE';
export const REDUCE_INDUSTRY = 'REDUCE_INDUSTRY';
export const REDUCE_MARKETPLACE_PRODUCTS = 'REDUCE_MARKETPLACE_PRODUCTS';
export const REDUCE_CUSTOMER = 'REDUCE_CUSTOMER';
export const REDUCE_CUSTOMER_ELEMENT = 'REDUCE_CUSTOMER_ELEMENT';
export const REDUCE_ATTACHMENTS = 'REDUCE_ATTACHMENTS';
export const CREATE_WORKFLOW = 'CREATE_WORKFLOW';
